import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { thunk } from "redux-thunk";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

import webSocketMiddleware from "#app/api/middleware/webSocketMiddleware";
import { baseApi } from "#app/api";

export default (initialState = {}) => {
    const sagaMiddleware = createSagaMiddleware();

    const composedEnhancers = compose(
        applyMiddleware(thunk, sagaMiddleware, webSocketMiddleware, baseApi.middleware)
    );

    const store = createStore(rootReducer(), initialState, composedEnhancers);

    sagaMiddleware.run(rootSaga);

    // if (process.env.NODE_ENV !== 'production') {
    //   if (module.hot) {
    //     module.hot.accept('./reducers', () => {
    //       store.replaceReducer(rootReducer)
    //     })
    //   }
    // }

    return store;
};
